import { BaseError, LoggableError, mergeLogOptions } from '../../../../../shared/helpers/errors';
import { SafeLogErrorOptions } from '../../../../../shared/helpers/log-error';
import { HaltReason } from '../constants';

export class RoomAgentHaltError extends BaseError {
    static from(error: unknown, loggerFields: SafeLogErrorOptions) {
        if (RoomAgentHaltError.is(error)) {
            return error;
        }

        if (LoggableError.is(error)) {
            return new RoomAgentHaltError(
                HaltReason.UNKNOWN_ERROR,
                error.message,
                mergeLogOptions(error.loggerFields, loggerFields),
                error.stack
            );
        }

        if (error instanceof Error) {
            return new RoomAgentHaltError(HaltReason.UNKNOWN_ERROR, error.message, loggerFields, error.stack);
        }

        return new RoomAgentHaltError(
            HaltReason.UNKNOWN_ERROR,
            typeof error === 'string' ? error : undefined,
            loggerFields
        );
    }

    constructor(
        public reason: HaltReason,
        public description: Maybe<string>,
        loggerFields: SafeLogErrorOptions,
        stack?: string
    ) {
        super(
            'Room agent halted',
            mergeLogOptions(loggerFields, {
                additional: {
                    reason,
                    description,
                },
            }),
            stack
        );

        Object.setPrototypeOf(this, RoomAgentHaltError.prototype);
    }
}
